<ped-svg-definitions></ped-svg-definitions>
<router-outlet></router-outlet>
